import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { X, Sparkles } from 'lucide-react'
import { analyticsService } from '@meiuca/analytics'
import { ANALYTICS_EVENTS } from '@/constants/analyticsEvents'

interface PreferencesBannerProps {
  onOpenModal: () => void
}

export function PreferencesBanner({ onOpenModal }: PreferencesBannerProps) {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = () => {
    setIsVisible(false)
    analyticsService.track(ANALYTICS_EVENTS.PREFERENCES_BANNER_CLOSED, {
      source: 'home_banner'
    })
  }

  const handleClick = () => {
    analyticsService.track(ANALYTICS_EVENTS.PREFERENCES_BANNER_CLICKED, {
      source: 'home_banner'
    })
    onOpenModal()
  }

  if (!isVisible) return null

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="sticky top-16 left-0 right-0 z-40 bg-gradient-to-r from-brand-primary to-brand-secondary shadow-md"
      >
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between py-3 gap-4">
            {/* Icon */}
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="flex-shrink-0">
                <Sparkles className="w-5 h-5 text-white" />
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0">
                <p className="text-white text-sm sm:text-base font-medium truncate">
                  Quer ver arenas mais relevantes para você?
                </p>
              </div>

              {/* CTA Button */}
              <button
                onClick={handleClick}
                className="flex-shrink-0 px-4 py-1.5 bg-white text-brand-primary rounded-lg text-sm font-semibold hover:bg-gray-50 transition-colors shadow-sm"
              >
                Escolher esportes
              </button>
            </div>

            {/* Close Button */}
            <button
              onClick={handleClose}
              className="flex-shrink-0 p-1 rounded-lg hover:bg-white/10 transition-colors"
              aria-label="Fechar"
            >
              <X className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  )
}
